module.exports = {
    METERTONAUTDEGREE: 111111,
}